<template>
  <v-container id="roadmap-item-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <material-card color="primary" icon="mdi-account-outline">
          <template #title>
            {{ isNewAction ? $t('new_roadmap_item') : $t('edit_roadmap_item') }}
          </template>

          <v-tabs vertical>
            <v-tab>
              <v-icon left>mdi-account</v-icon>
              {{ $t('general') }}
            </v-tab>
            <v-tab>
              <v-icon left>mdi-lock</v-icon>
              {{ $t('images') }}
            </v-tab>
            <v-tab-item>
              <general-tab ref="general_tab" :item="item" />
            </v-tab-item>
            <v-tab-item>
              <images-tab ref="images_tab" :item="item" />
            </v-tab-item>
          </v-tabs>
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="text-left">
                <v-btn v-if="!isNewAction" min-width="150" @click="deleteItem">
                  {{ $t('delete') }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" class="text-right">
                <v-btn color="primary" min-width="150" @click="submit">
                  {{ $t('save') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import GeneralTab from '@/components/Settings/Landing/Roadmap/Edit/Tabs/GeneralTab'
import ImagesTab from '@/components/Settings/Landing/Roadmap/Edit/Tabs/ImagesTab'
export default {
  name: 'EditRoadmapItem',
  components: {
    GeneralTab,
    ImagesTab,
  },
  data: () => ({
    loading: false,
    item: {
      id: null,
      title: '',
      description: '',
      category: '',
      date: '',
      images: [],
      language: 'uk',
    },
  }),
  async mounted () {
    if (!this.isNewAction) {
      await this.loadItem({ item_id: this.$route.params.id })
        .then(result => {
          this.item = result.data
        })
    }
  },
  methods: {
    ...mapActions({
      loadItem: 'settings/landing/roadmap/loadRoadmapItem',
      updateItem: 'settings/landing/roadmap/update',
      removeItem: 'settings/landing/roadmap/delete',
      createItem: 'settings/landing/roadmap/create',
    }),
    runItemUpdate () {
      this.$bus.$emit('roadmap-item-update-run')
      const form = new FormData()
      form.append('item_id', this.item.id)
      Object.keys(this.$refs.general_tab.newItemData).forEach(key => {
        if (key !== 'images') {
          form.append(key, this.$refs.general_tab.newItemData[key])
        }
      })
      // TODO: This should be replaced with the dropzone
      this.$refs.images_tab.newItemData.images.forEach((file, i) => {
        form.append(`images[${i}]`, file, file.name)
      })
      this.updateItem(form)
    },
    runItemCreate () {
      const form = new FormData()
      Object.keys(this.$refs.general_tab.newItemData).forEach(key => {
        if (key !== 'images') {
          form.append(key, this.$refs.general_tab.newItemData[key])
        }
      })
      // TODO: This should be replaced with the dropzone
      this.$refs.images_tab.newItemData.images.forEach((file, i) => {
        form.append(`images[${i}]`, file, file.name)
      })
      this.createItem(form)
        .then(result => {
          this.$router.push(`/settings/landing/roadmap/${result.data.id}`)
        })
    },
    submit () {
      if (this.isNewAction) {
        this.runItemCreate()
      } else {
        this.runItemUpdate()
      }
    },
    deleteItem () {
      this.removeItem({ item_id: this.item.id })
        .then(() => {
          this.$router.push('/settings/landing/roadmap/')
        })
    },
  },
  computed: {
    isNewAction () {
      return this.$route.params.id === 'new'
    },
  },
}
</script>
